// extracted by mini-css-extract-plugin
export default {"HalfHalf":"index_HalfHalf__2sWDd"};